import React from "react";
import { Date } from "components/Shared";
import _ from "lodash";
import { translate } from "lib";

// eslint-disable-next-line
const ProjectBlock = () => null;
// eslint-disable-next-line
const Inspection = ({ documentable }) => (
  <React.Fragment>
    <h1>{documentable.name} </h1>
    {_.map(documentable.facilities, facility => {
      return <h2>{facility.name}</h2>;
    })}
  </React.Fragment>
);
// eslint-disable-next-line
const LedgerBlock = () => null;
// eslint-disable-next-line
const Lease = ({ documentable }) => (
  <React.Fragment>
    <h1>Your Lease</h1>
    <h3>{translate("details")}</h3>
    <table>
      <tbody>
        {!!_.get(documentable, "status") && (
          <tr>
            <th style={{ width: "40%" }}>{translate("status")}</th>
            <td>{_.get(documentable, "status")}</td>
          </tr>
        )}
        {!!_.get(documentable, "kind") && (
          <tr>
            <th style={{ width: "40%" }}>{translate("kind")}</th>
            <td>{_.get(documentable, "kind")}</td>
          </tr>
        )}
        {!!_.get(documentable, "incentives") && (
          <tr>
            <th style={{ width: "40%" }}>{translate("incentives")}</th>
            <td>{_.get(documentable, "incentives")}</td>
          </tr>
        )}
        {!!_.get(documentable, "net_lettable_area") && (
          <tr>
            <th style={{ width: "40%" }}>{translate("net_lettable_area")}</th>
            <td>
              {_.get(documentable, "net_lettable_area")}m<sup>2</sup>
            </td>
          </tr>
        )}
        {!!_.get(documentable, "seating_area") && (
          <tr>
            <th style={{ width: "40%" }}>{translate("seating_area")}</th>
            <td>
              {_.get(documentable, "seating_area")}m<sup>2</sup>
            </td>
          </tr>
        )}
        {!!_.get(documentable, "storage_area") && (
          <tr>
            <th style={{ width: "40%" }}>{translate("storage_area")}</th>
            <td>
              {_.get(documentable, "storage_area")}m<sup>2</sup>
            </td>
          </tr>
        )}
        {!!_.get(documentable, "permitted_use") && (
          <tr>
            <th style={{ width: "40%" }}>{translate("permitted_use")}</th>
            <td>{_.get(documentable, "permitted_use")}</td>
          </tr>
        )}
        {!!_.get(documentable, "lease_renewals") && (
          <tr>
            <th style={{ width: "40%" }}>{translate("lease_renewals")}</th>
            <td>{_.get(documentable, "lease_renewals")}</td>
          </tr>
        )}
        {!!_.get(documentable, "facilities") && (
          <tr>
            <th style={{ width: "40%" }}>{translate("facilities")}</th>
            <td>{_.get(documentable, "facilities")}</td>
          </tr>
        )}
      </tbody>
    </table>
    <h3>{translate("lease_schedule")}</h3>
    <table>
      <tbody>
        {!!_.get(documentable, "vacant_possession_at") && (
          <tr>
            <th style={{ width: "40%" }}>{translate("vacant_possession_at")}</th>
            <td>
              <Date date={_.get(documentable, "vacant_possession_at")} />
            </td>
          </tr>
        )}
        {!!_.get(documentable, "starts_at") && (
          <tr>
            <th style={{ width: "40%" }}>{translate("starts_at")}</th>
            <td>
              <Date date={_.get(documentable, "starts_at")} />
            </td>
          </tr>
        )}
        {!!_.get(documentable, "ends_at") && (
          <tr>
            <th style={{ width: "40%" }}>{translate("ends_at")}</th>
            <td>
              <Date date={_.get(documentable, "ends_at")} />
            </td>
          </tr>
        )}
        {!!_.get(documentable, "duration") && (
          <tr>
            <th style={{ width: "40%" }}>{translate("duration")}</th>
            <td>
              <Date date={_.get(documentable, "duration")} />
            </td>
          </tr>
        )}
        {!!_.get(documentable, "handover_at") && (
          <tr>
            <th style={{ width: "40%" }}>{translate("handover_at")}</th>
            <td>
              <Date date={_.get(documentable, "handover_at")} />
            </td>
          </tr>
        )}
        {!!_.get(documentable, "fitout_ends_at") && (
          <tr>
            <th style={{ width: "40%" }}>{translate("fitout_ends_at")}</th>
            <td>
              <Date date={_.get(documentable, "fitout_ends_at")} />
            </td>
          </tr>
        )}

        {!!_.get(documentable, "opening_at") && (
          <tr>
            <th style={{ width: "40%" }}>{translate("opening_at")}</th>
            <td>
              <Date date={_.get(documentable, "opening_at")} />
            </td>
          </tr>
        )}
        {!!_.get(documentable, "rent_starts_at") && (
          <tr>
            <th style={{ width: "40%" }}>{translate("rent_starts_at")}</th>
            <td>
              <Date date={_.get(documentable, "rent_starts_at")} />
            </td>
          </tr>
        )}
      </tbody>
    </table>
    <h3>{translate("financial_schedule")}</h3>
    <table>
      <tbody>
        {!!_.get(documentable, "base_rent_cents") && (
          <tr>
            <th style={{ width: "40%" }}>{translate("base_rent_cents")}</th>
            <td>{_.get(documentable, "base_rent_cents")}</td>
          </tr>
        )}
        {!!_.get(documentable, "outgoings_cents") && (
          <tr>
            <th style={{ width: "40%" }}>{translate("outgoings_cents")}</th>
            <td>{_.get(documentable, "outgoings_cents")}</td>
          </tr>
        )}
        {!!_.get(documentable, "rent_percent") && (
          <tr>
            <th style={{ width: "40%" }}>{translate("rent_percent")}</th>
            <td>{_.get(documentable, "rent_percent")}</td>
          </tr>
        )}
        {!!_.get(documentable, "rent_review_percent") && (
          <tr>
            <th style={{ width: "40%" }}>{translate("rent_review_percent")}</th>
            <td>{_.get(documentable, "rent_review_percent")}</td>
          </tr>
        )}
        {!!_.get(documentable, "base_rent_frequency") && (
          <tr>
            <th style={{ width: "40%" }}>{translate("base_rent_frequency")}</th>
            <td>{_.get(documentable, "base_rent_frequency")}</td>
          </tr>
        )}
        {!!_.get(documentable, "annual_review") && (
          <tr>
            <th style={{ width: "40%" }}>{translate("annual_review")}</th>
            <td>{_.get(documentable, "annual_review")}</td>
          </tr>
        )}
        {!!_.get(documentable, "fitout_contribution_cents") && (
          <tr>
            <th style={{ width: "40%" }}>{translate("fitout_contribution_cents")}</th>
            <td>{_.get(documentable, "fitout_contribution_cents")}</td>
          </tr>
        )}
        {!!_.get(documentable, "operational_outgoings_cents") && (
          <tr>
            <th style={{ width: "40%" }}>{translate("operational_outgoings_cents")}</th>
            <td>{_.get(documentable, "operational_outgoings_cents")}</td>
          </tr>
        )}
        {!!_.get(documentable, "rent_per_sqm_cents") && (
          <tr>
            <th style={{ width: "40%" }}>{translate("rent_per_sqm_cents")}</th>
            <td>{_.get(documentable, "rent_per_sqm_cents")}</td>
          </tr>
        )}
        {!!_.get(documentable, "statutory_outgoings_cents") && (
          <tr>
            <th style={{ width: "40%" }}>{translate("statutory_outgoings_cents")}</th>
            <td>{_.get(documentable, "statutory_outgoings_cents")}</td>
          </tr>
        )}
      </tbody>
    </table>
  </React.Fragment>
);

const Task = ({ documentable }) => (
  <React.Fragment>
    <h3>{translate("conditions")}</h3>
    <table>
      <tbody>
        {_.map(_.sortBy(_.get(documentable, "conditions", []), "name"), row => {
          let value = "";
          if (!!row.dismissed_at) {
            value = translate("dismissed");
          } else if (row.kind === "date") {
            value = <Date date={row.response} showTime={false} />;
          } else if (row.kind === "document") {
            value = "";
          } else if (row.kind === "accept") {
            value = !!row.completed_at ? translate("accepted") : translate("rejected");
          } else if (row.kind === "boolean") {
            value = !!row.accepted_at ? translate("yes") : translate("no");
          }
          return (
            <tr className={!!_.get(row, "dismissed_at") && "dismissed"}>
              <td
                style={{
                  textAlign: "left",
                  width: "32px",
                  textDecoration: !!_.get(row, "dismissed_at") && "line-through"
                }}
              >
                {!!row.closed_at && !row.dismissed_at ? "‎✔" : "✖"}
              </td>
              <td style={{ width: "70%", textDecoration: !!_.get(row, "dismissed_at") && "line-through" }}>
                <h4 style={{ fontFamily: "sans-serif", margin: 0 }}>{row.name}</h4>
                {!!row.description && <p style={{ margin: 0 }}>{row.description}</p>}
              </td>
              <td style={{ textDecoration: !!_.get(row, "dismissed_at") && "line-through" }}>{value}</td>
            </tr>
          );
        })}
      </tbody>
    </table>
  </React.Fragment>
);

export default class Document extends React.Component {
  render() {
    const { document, documentable } = this.props;
    const output = _.map(_.get(document, "body.blocks", []), ({ type, data }, blockIndex) => {
      switch (type) {
        case "header":
          return React.createElement(
            `h${_.get(data, "level", 1)}`,
            { key: `index-${blockIndex}`, style: { fontFamily: "sans-serif" } },
            _.get(data, "text", "").replace("<br>", "")
          );
        case "merge":
          switch (_.get(document, "documentable_type")) {
            case "Task":
              return <Task {...{ document, documentable }} key={"task-blcok"} />;
            case "Lease":
              return <Lease {...{ document, documentable }} key={"lease-blcok"} />;
            case "Inspection":
              return <Inspection {...{ document, documentable }} key={"inspection-block"} />;
            default:
              return false;
          }

        case "paragraph":
          return <p key={`index-${blockIndex}`}>{_.get(data, "text", "").replace("<br>", "")}</p>;
        case "quote":
          return (
            <blockquote key={`index-${blockIndex}`}>
              {_.get(data, "text", "").replace("<br>", "")}
              <cite>{_.get(data, "caption", "").replace("<br>", "")}</cite>
            </blockquote>
          );
        case "list":
          const items = _.map(_.get(data, "items", []), (item, index) => (
            <li key={`li-${index}`}>{item.replace("<br>", "")}</li>
          ));
          if (_.get(data, "style", "unordered") === "ordered") {
            return <ol key={`index-${blockIndex}`}>{items}</ol>;
          } else {
            return <ul key={`index-${blockIndex}`}>{items}</ul>;
          }
        case "checklist":
          const checklistItems = _.map(_.get(data, "items", []), (item, index) => (
            <li key={`li-${index}`}>
              <span className="fa-li">
                {!!item.checked ? <i className="fas fa-check-circle" /> : <i className="far fa-circle" />}
              </span>
              {item.text.replace("<br>", "")}
            </li>
          ));
          return (
            <ul className="fa-ul checklist" key={`index-${blockIndex}`}>
              {checklistItems}
            </ul>
          );
        case "delimiter":
          return <hr key={`index-${blockIndex}`} />;
        case "link":
          return (
            <p key={`index-${blockIndex}`}>
              <a href={_.get(data, "link")}>{_.get(data, "link")}</a>
            </p>
          );
        case "code":
          return <samp key={`index-${blockIndex}`}>{_.get(data, "code", "")}</samp>;
        case "warning":
          return (
            <div className="alert alert-warning" key={`index-${blockIndex}`}>
              <h6>{_.get(data, "title", "")}</h6>
              {_.get(data, "message", "")}
            </div>
          );
        default:
          return null;
      }
    });
    return (
      <div
        id="document-preview"
        className="document"
        style={{ lineHeight: 1.3, fontWeight: "200", fontFamily: "sans-serif", fontSize: "14px" }}
      >
        {_.compact(output)}
      </div>
    );
  }
}
